<script setup lang='ts'>
import { logicDealerList } from '~/logic/common/dealer'
import type { DealerResponse } from '@/server/types'

const props = withDefaults(defineProps<{
  provinceId?: string | number
  cityId?: string | number
  seriesId?: string | number
  customDealer?: string
}>(), {
  customDealer: '',
})
const emits = defineEmits({
  dealerSelect: (_data: DealerResponse) => true,
})

const drawer = ref(false)
const customDealer = ref(props.customDealer || '')
function submit(_data: DealerResponse) {
  drawer.value = false
  emits('dealerSelect', _data)
}

const {
  list,
  state,
  getDealerList,
} = logicDealerList()

function validator() {
  if (!props.seriesId) {
    useMessage.warning('请先选择车系', { closable: true })
    return false
  }
  if (!props.provinceId || !props.cityId) {
    useMessage.warning('请先选择经销商所在省市', { closable: true })
    return false
  }
  return true
}
function showDrawer() {
  if (!validator())
    return

  drawer.value = true
  if (list.value.length === 0)
    getData()
}

async function getData() {
  if (!validator())
    return
  await getDealerList({
    provinceId: props.provinceId as number,
    cityId: props.cityId as number,
    seriesId: props.seriesId as number,
  })
}
watch(() => [props.provinceId, props.cityId, props.seriesId], () => {
  list.value = []
})
</script>

<template>
  <div>
    <div @click="showDrawer()">
      <slot>
        选择经销商
      </slot>
    </div>
    <NDrawer
      v-model:show="drawer"
      placement="left"
      width="500px"
      :trap-focus="false"
      :block-scroll="false"
      display-directive="show"
    >
      <NDrawerContent closable title="选择经销商">
        <template #default>
          <div class="overflow-hidden h-full">
            <UtilLoadState :state="state" :reload-handler="() => getData()">
              <NScrollbar v-if="list && list.length" class="pr-sm">
                <div
                  v-for="v, i in list" :key="i"
                  class="shadow p-sm rounded-md border-1 border-slate-2 mb-sm cursor-pointer" @click="submit(v)"
                >
                  <p>经销商名称：{{ v.dealerNameSimple }}</p>
                  <p>联系电话：{{ v.dealerPhone }}</p>
                </div>
              </NScrollbar>
              <BasicEmpty v-else />
            </UtilLoadState>
          </div>
        </template>
        <template #footer>
          <div class="w-full mb-sm">
            <p class="text-red-5 text-3 mb-2">
              *如无相关经销商，可直接在输入框中输入经销商名字，点击确定即可
            </p>
            <div class="flex items-center w-full">
              <NInput v-model:value="customDealer" flex-grow placeholder="自定义经销商" />
              <NButton
                type="primary" class="px-6 ml-sm" @click="submit({
                  id: -1,
                  dealerNameSimple: customDealer,
                  dealerPhone: '',
                  dealerLinkman: '',
                })"
              >
                确定
              </NButton>
            </div>
          </div>
        </template>
      </NDrawerContent>
    </NDrawer>
  </div>
</template>

<style lang='scss' scoped>

</style>
